/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import VdiModel, { REMOTE_DESKTOP_TYPE } from './VdiModel';
import { IResourceProps } from 'apmui/resource/ResourceLoader';

class CitrixModel extends VdiModel {
    // static
    static readonly propNames = [...VdiModel.propNames];

    launchCookie?: string;
    launchUri?: string;
    restartUri?: string;

    rdType: REMOTE_DESKTOP_TYPE.CITRIX = REMOTE_DESKTOP_TYPE.CITRIX;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);

        this.launchCookie = resource.props.launchCookie;
        this.launchUri = resource.props.launchUri;
        this.restartUri = resource.props.restartUri;
    }

    getPropNames() {
        return CitrixModel.propNames;
    }
}

export { CitrixModel as default, CitrixModel };
